import { EMPTY_OBJECT } from '../../../constants/common'
import { IconNG } from '../../Icon'
import { getTagActionSize, Tag, TAG_HEIGHT, TagAvatar } from '../../Tag'

function EntityTag({
  Icon,
  avatarProps,
  height = TAG_HEIGHT.height32,
  iconProps: { size: iconSize, ...iconProps } = EMPTY_OBJECT,
  name,
  ...restProps
}) {
  const actionSize = getTagActionSize(height)

  const avatar = avatarProps ? (
    <TagAvatar {...avatarProps} size={avatarProps.size ?? actionSize} />
  ) : null

  const icon = Icon ? (
    <IconNG {...iconProps} Icon={Icon} size={iconSize ?? actionSize} />
  ) : null

  return (
    <Tag
      {...restProps}
      beforeContent={avatar || icon}
      height={height}
      text={name}
    />
  )
}

export default EntityTag
